import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import secureSession from "src/pages/hr/SecureSession"
import "./Naggy.css"

interface DoublepanelDiscardNagProps {
    disabledElements: Array<string>
    postPropagationClicks?: Array<string>
    isDirty: boolean
    toggleDirty?: Function
    discard?: Function
    cancleSecureSesion?: boolean
    message: String
    exitBtnText?: string
}

type DoublepanelDiscardNagTypes = {
    showModal: boolean
}

class DoublepanelDiscardNag extends Component<DoublepanelDiscardNagProps, DoublepanelDiscardNagTypes> {

    orignalEvents: any = []
    originalLinks: Array<HTMLAnchorElement | HTMLAreaElement> = []

    state = {
        showModal: false,
    }

    componentDidUpdate(prevProps: DoublepanelDiscardNagProps) {
        if (prevProps.isDirty !== this.props.isDirty) {
            if (this.props.isDirty) {
                this.disablePropagation()
            } else {
                this.allowPropagation()
            }
        }
    }

    componentWillUnmount() {
        this.allowPropagation()

    }

    disablePropagation = () => {
        for (let i = 0; i < this.props.disabledElements.length; i++) {
            let elem = document.getElementById(this.props.disabledElements[i])
            if (elem) {
                elem.onclick = (e) => {
                    this.orignalEvents[i] = (e)
                    e.stopImmediatePropagation()
                    this.toggleModal(true)
                }
            }
        }
    }

    allowPropagation = () => {
        for (let i = 0; i < this.props.disabledElements.length; i++) {
            let elem = document.getElementById(this.props.disabledElements[i])
            if (elem) {
                elem.onclick = () => this.orignalEvents[i]
                this.toggleModal(false)
            }
        }
        // if (this.props.postPropagationClicks) {
        //     for (let i = 0; i < this.props.postPropagationClicks.length; i++) {
        //         let elem = document.getElementById(this.props.postPropagationClicks[i])
        //         if (elem) {
        //             setTimeout(() => {
        //                 //@ts-ignore
        //                 elem.click()
        //                 //console.log(elem)
        //             }, 200)
        //         }
        //     }
        // }
    }

    toggleModal = (show: boolean) => {
        if (this.state.showModal !== show) {
            this.setState({ showModal: show })
        }
    }

    discard = () => {
        if (this.props.toggleDirty) {
            this.props.toggleDirty(false)
        }
        if (this.props.discard) {
            this.props.discard()
        }
        this.setState({ showModal: false })
        if(this.props.cancleSecureSesion){
            secureSession.cancel()
        }
    }

    render() {

        const props = this.props
        const exitBtnText = props.exitBtnText? props.exitBtnText : "Discard"

        return (
            <div className="DoublepanelDiscardNag" id="double-panel-discard-nag">
                {this.state.showModal && <Modal id="double-panel-discard-nag-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div id="double-panel-discard-nag-header">
                            <p id="double-panel-discard-nag-msg">{props.message}</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div id="double-panel-discard-nag-footer" >
                            <Button id="double-panel-discard-nag-footer-back-btn" variant="secondary" onClick={() => this.toggleModal(false)}>Back</Button>
                            <Button id="double-panel-discard-nag-footer-discard-btn" variant="danger" onClick={() => this.discard()}>{exitBtnText}</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

export default DoublepanelDiscardNag